import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { CONTACT } from '../data/site';

const REVIEWS = [
  {
    quote:
      'Diferencial: a carne é feita por eles. Simplesmente 10/10 no sabor e no ponto da carne.',
    author: 'Danielle C. Stutz',
    meta: 'Guia local · Google',
  },
  {
    quote: 'Lanches sensacionais… foi o melhor sanduíche de frango que já comi!!!',
    author: 'Cliente da casa',
    meta: 'Avaliação no Google',
  },
  {
    quote:
      'Pão australiano, blend de 120g, cheddar, cebola caramelizada e molho especial. Por 26 reais.',
    author: 'Marlon Pereira',
    meta: 'Guia local · Google',
  },
];

export default function Reviews() {
  return (
    <section id="avaliacoes" className="bg-[#101013] py-24 sm:py-32" data-testid="avaliacoes-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="font-mono-alt text-xs font-semibold uppercase tracking-[0.3em] text-[#FFB800]"
        >
          Avaliações
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-4 font-display text-5xl uppercase leading-none text-white sm:text-6xl"
        >
          Quem prova, volta
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="font-serif-accent mt-4 text-xl text-zinc-400"
        >
          Avaliações reais de clientes, direto do Google.
        </motion.p>

        <motion.a
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, delay: 0.25 }}
          href={CONTACT.mapsPlace}
          target="_blank"
          rel="noreferrer"
          data-testid="avaliacoes-google-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#FFB800]/40 bg-[#0D0D0F]/60 px-5 py-2.5 text-sm font-bold text-[#FFB800] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_24px_rgba(255,184,0,0.25)]"
        >
          <Star size={16} className="fill-[#FFB800]" /> 4,5 no Google · 41 avaliações
        </motion.a>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {REVIEWS.map((review, i) => (
            <motion.figure
              key={review.author}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              whileHover={{ y: -6 }}
              className="rounded-3xl border border-white/10 bg-[#141418] p-8 transition-colors duration-300 hover:border-[#FFB800]/40"
              data-testid={`avaliacoes-card-${i}`}
            >
              <div className="flex gap-1" aria-label="Nota 5 de 5 estrelas">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={16} className="fill-[#FFB800] text-[#FFB800]" />
                ))}
              </div>
              <blockquote className="mt-5 text-base leading-relaxed text-zinc-200">
                “{review.quote}”
              </blockquote>
              <figcaption className="mt-6">
                <p className="font-bold text-white">{review.author}</p>
                <p className="text-sm text-zinc-500">{review.meta}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
